import {flattenDeep, pathFromDirectories, queryFromParams} from '../services/utils';

export const HOST_URL = 'https://api.smartmeeting.online/';
export const CONFIG_PATH = 'api/plugin/hosted/';

export const configPath = (path, params) => {
    return pathFromDirectories(...flattenDeep([HOST_URL, CONFIG_PATH, path])) + queryFromParams(params);
};